webpackJsonp([0,37],{

/***/ 1108:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1109);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(49)("51b8e0cc", content, true, {});

/***/ }),

/***/ 1109:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(38)(false);
// imports


// module
exports.push([module.i, ".modal .modal-huge{max-width:900px;width:900px;max-height:500px;height:500px}.modal-backdrop{background:#002646a8}.modal-content{border:0;border-radius:20px;border:1px solid #e0e0e0}.modal-body,.modal-header{box-shadow:none}", ""]);

// exports


/***/ }),

/***/ 1110:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1111);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(49)("ad534626", content, true, {});

/***/ }),

/***/ 1111:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(38)(false);
// imports


// module
exports.push([module.i, ".header-nav{background:#e9ecef;padding:15px 0;color:#06c}.subtitulo{min-height:57px;position:relative;display:flex;align-items:center}.col-md-12{padding-right:15px!important}", ""]);

// exports


/***/ }),

/***/ 1112:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"card card-muni",class:{ loginuser: _vm.$root.$userLogged }},[_c('div',{staticClass:"row"},_vm._l((_vm.lisItems),function(item,index){return _c('div',{key:index,staticClass:"col-6 col-md-3"},[_c('div',{staticClass:"item"},[_c('a',{on:{"click":function($event){$event.preventDefault();return _vm.validaOpc(item.login, item.link)}}},[_c('div',{staticClass:"content-img"},[_c('img',{attrs:{"src":__webpack_require__(663)("./" + (item.icon) + ".png")}})]),_vm._v(" "),_c('h5',[_c('b',[_vm._v(" "+_vm._s(item.title))])]),_vm._v(" "),(item.conIconDes == 0)?[_c('p',[_vm._v(_vm._s(item.description))])]:[_c('img',{attrs:{"src":__webpack_require__(663)("./" + (item.description) + ".png")}})]],2)])])}),0)]),_vm._v(" "),_c('div',{staticClass:"card card-muni",class:{ loginuser: _vm.$root.$userLogged }},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6",staticStyle:{"margin-left":"30px !important"}},[_c('ol',_vm._l((_vm.lisItemsPagoDirecto),function(requisito){return _c('li',{key:requisito.idRequisitoTramite},[_c('a',{staticStyle:{"text-decoration":"underline"},attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.verTramitePagoDirecto(requisito)}}},[_vm._v("\n                   "+_vm._s(requisito.nombreRequisitoTramite)+" \n                  ")])])}),0),_vm._v(" "),_c('br')])])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"modalCasillaElectronica","hide-footer":"","title":""},on:{"hidden":_vm.clearData}},[_c('div',{staticClass:"form-group",staticStyle:{"margin-bottom":"0.5rem"}},[_c('div',{staticClass:"row mt-2"},[_c('div',{staticClass:"col-md-12 pr-0"},[_c('div',{staticClass:"mt-12",staticStyle:{"text-align":"center","color":"#0078cf"}},[_c('h5',[_c('b',[_vm._v(" AUTORIZACIÓN DE USO DE CASILLA ELECTRÓNICA ")])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12",staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"custom-control custom-checkbox my-1 mr-sm-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.flagCasillaElectronica),expression:"flagCasillaElectronica"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customControlInline"},domProps:{"checked":Array.isArray(_vm.flagCasillaElectronica)?_vm._i(_vm.flagCasillaElectronica,null)>-1:(_vm.flagCasillaElectronica)},on:{"change":function($event){var $$a=_vm.flagCasillaElectronica,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.flagCasillaElectronica=$$a.concat([$$v]))}else{$$i>-1&&(_vm.flagCasillaElectronica=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.flagCasillaElectronica=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customControlInline"}},[_c('b',[_vm._v("He leído y acepto términos y condiciones")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12",staticStyle:{"text-align":"center","color":"#0078cf"}},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":_vm.openModalCasillaElectronica}},[_c('u',[_vm._v(" Ver términos y condiciones ")])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12",staticStyle:{"text-align":"center"}},[_c('button',{staticClass:"btn btn-default",on:{"click":_vm.ActualizaFlagCasillaElectronica}},[_vm._v("\n                  Confirmar\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.omitir}},[_vm._v("\n                  Omitir\n                ")])])])])])])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"visorModal","hide-footer":"","title":"Términos y Condiciones","size":"huge"}},[_c('div',{staticClass:"contenedor-documento"},[_c('div',{staticClass:"row"},[_c('div',{staticStyle:{"width":"95%"}},[_c('iframe',{staticStyle:{"width":"100%","height":"900px"},attrs:{"src":_vm.rutaTerminosCasilla,"type":"application/pdf","frameborder":"0"}})])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('h3',[_vm._v("Pago Directo")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 356:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(666);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93ca9faa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(838);
var normalizeComponent = __webpack_require__(347)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93ca9faa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Plataforma_vue__ = __webpack_require__(956);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ebd8b3f0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Plataforma_vue__ = __webpack_require__(1112);
function injectStyle (ssrContext) {
  __webpack_require__(1108)
  __webpack_require__(1110)
}
var normalizeComponent = __webpack_require__(347)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Plataforma_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ebd8b3f0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Plataforma_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 583:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(584), __esModule: true };

/***/ }),

/***/ 584:
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(57);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),

/***/ 586:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var util = {};
util.storage = {};
util.pagina = {};
util.alert = {};

// Utilidades para LocalStorage
util.storage.get = function (item) {
    if (localStorage.getItem(item) != null) {
        return JSON.parse(localStorage.getItem(item));
    } else {
        return null;
    }
};

util.storage.set = function (item, data) {
    localStorage.setItem(item, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
};

util.storage.delete = function (item) {
    localStorage.removeItem(item);
};

util.limpiarStorage = function () {
    localStorage.clear();
};

// Utilidades para alertas
util.alert.success = function (entorno, titulo, mensaje) {
    entorno.$swal({
        toast: true,
        position: "top",
        showConfirmButton: false,
        timer: 5500,
        timerProgressBar: true,
        icon: 'success',
        title: titulo,
        text: mensaje
    });
};

util.alert.custom = function (entorno, type, titulo, mensaje) {
    entorno.$swal({
        toast: true,
        position: "top",
        showConfirmButton: false,
        timer: 5500,
        timerProgressBar: true,
        icon: type,
        title: titulo,
        text: mensaje
    });
};

// Otras Utilidades
util.cerrarSesion = function (entorno) {
    localStorage.clear();
    entorno.$router.push("/login");
};

util.pagina.go = function (entorno, pagina) {
    entorno.$router.push(pagina);
};

util.pagina.anterior = function (entorno) {
    entorno.$router.go(-1);
};

/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),

/***/ 590:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getAccesoLogin */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getContribuyente; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getHabilitaPagina; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getEstadoCuenta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getEstadoCuentaSec; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getPredios; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return setSeleccionaPredios; });
/* unused harmony export printEstadoCuenta */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDataCuenta; });
/* unused harmony export getContribuyenteEstadoCuenta */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getEstadoCuentaDescarga; });
/* unused harmony export getEstadoDescargaCuponera */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getContribuyenteotro; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setCostaProcesal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_constantes__ = __webpack_require__(345);



var API_RENTAS = __WEBPACK_IMPORTED_MODULE_1__store_constantes__["a" /* default */].API_RENTAS;
var API_ACCESOS = __WEBPACK_IMPORTED_MODULE_1__store_constantes__["a" /* default */].rutaAccesos;

var getAccesoLogin = function getAccesoLogin(migrarUsuario, dataLogin) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(API_RENTAS + '/acceso', dataLogin, { params: { "guardarEnPtdGenUsuario": migrarUsuario } });
};
var getContribuyente = function getContribuyente(nroDocumento) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(API_RENTAS + '/contribuyente/' + nroDocumento);
};
var getHabilitaPagina = function getHabilitaPagina(request) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(API_ACCESOS + 'habilitaPagina/', request);
};
var getContribuyenteotro = function getContribuyenteotro(nroDocumento) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(API_RENTAS + '/contribuyenteotro/' + nroDocumento);
};
var getContribuyenteEstadoCuenta = function getContribuyenteEstadoCuenta(nroDocumento) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(API_RENTAS + '/contribuyente-estadocuenta/' + nroDocumento);
};
var getEstadoCuenta = function getEstadoCuenta(tdi, con, estado) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(API_RENTAS + '/estado-cuenta/' + tdi + '/' + con + '/' + estado);
};
var getEstadoCuentaSec = function getEstadoCuentaSec(codEmision) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(API_RENTAS + '/estado-cuenta/' + codEmision);
};
var getDataCuenta = function getDataCuenta(codigoCuentaRequest) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(API_RENTAS + '/estado-cuenta/codigo-cuenta', codigoCuentaRequest);
};
var getPredios = function getPredios(codEmision) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(API_RENTAS + '/estado-cuenta/predios/' + codEmision);
};
var setSeleccionaPredios = function setSeleccionaPredios(prediosSeleccionadosRequest) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(API_RENTAS + '/estado-cuenta/selecciona-predios', prediosSeleccionadosRequest);
};
var printEstadoCuenta = function printEstadoCuenta(codEmision) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(API_RENTAS + '/estado-cuenta/imprimir-eecc/' + codEmision);
};
var getEstadoCuentaDescarga = function getEstadoCuentaDescarga(dataUsuario) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(API_RENTAS + '/estado-cuenta/descargar-eecc', dataUsuario);
};
var getEstadoDescargaCuponera = function getEstadoDescargaCuponera(dniUsuario, token) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(API_RENTAS + '/validacionCup/' + dniUsuario + '/' + token);
};
var setCostaProcesal = function setCostaProcesal(reciboSeleccionadosRequest) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(API_RENTAS + '/estado-cuenta/valida-costas', reciboSeleccionadosRequest);
};



/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(349);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ 602:
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(171);
var TAG = __webpack_require__(50)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(64);
var aFunction = __webpack_require__(349);
var SPECIES = __webpack_require__(50)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(348);
var invoke = __webpack_require__(626);
var html = __webpack_require__(354);
var cel = __webpack_require__(172);
var global = __webpack_require__(31);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(171)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),

/***/ 605:
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),

/***/ 606:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(64);
var isObject = __webpack_require__(58);
var newPromiseCapability = __webpack_require__(591);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "success.png?53252348748e49ab1d6462042aa3fbd3";

/***/ }),

/***/ 609:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "pdf.png?26fe8d5d67ba65e2e5ddc9a8b08bfd4c";

/***/ }),

/***/ 610:
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),

/***/ 611:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "flecha_derecha.png?d1009cc4ce3a081670ec3691bb9ef0f7";

/***/ }),

/***/ 613:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ask.png?734f2d6ef55a34a96c078e8e1663f0c9";

/***/ }),

/***/ 614:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(618);


/***/ }),

/***/ 615:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(619);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),

/***/ 616:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(602);
var ITERATOR = __webpack_require__(50)('iterator');
var Iterators = __webpack_require__(97);
module.exports = __webpack_require__(57).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ 617:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "adjuntar.png?72a4f6636dc439aa73b403a5d5b072f2";

/***/ }),

/***/ 618:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(610);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),

/***/ 619:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(620), __esModule: true };

/***/ }),

/***/ 620:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(353);
__webpack_require__(350);
__webpack_require__(351);
__webpack_require__(621);
__webpack_require__(632);
__webpack_require__(633);
module.exports = __webpack_require__(57).Promise;


/***/ }),

/***/ 621:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(65);
var global = __webpack_require__(31);
var ctx = __webpack_require__(348);
var classof = __webpack_require__(602);
var $export = __webpack_require__(96);
var isObject = __webpack_require__(58);
var aFunction = __webpack_require__(349);
var anInstance = __webpack_require__(622);
var forOf = __webpack_require__(623);
var speciesConstructor = __webpack_require__(603);
var task = __webpack_require__(604).set;
var microtask = __webpack_require__(627)();
var newPromiseCapabilityModule = __webpack_require__(591);
var perform = __webpack_require__(605);
var userAgent = __webpack_require__(628);
var promiseResolve = __webpack_require__(606);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(50)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(629)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(98)($Promise, PROMISE);
__webpack_require__(630)(PROMISE);
Wrapper = __webpack_require__(57)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(631)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),

/***/ 622:
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),

/***/ 623:
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(348);
var call = __webpack_require__(624);
var isArrayIter = __webpack_require__(625);
var anObject = __webpack_require__(64);
var toLength = __webpack_require__(352);
var getIterFn = __webpack_require__(616);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),

/***/ 624:
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(64);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ 625:
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(97);
var ITERATOR = __webpack_require__(50)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ 626:
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),

/***/ 627:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(31);
var macrotask = __webpack_require__(604).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(171)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),

/***/ 628:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(31);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),

/***/ 629:
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(53);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),

/***/ 630:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(31);
var core = __webpack_require__(57);
var dP = __webpack_require__(52);
var DESCRIPTORS = __webpack_require__(39);
var SPECIES = __webpack_require__(50)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(50)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ 632:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(96);
var core = __webpack_require__(57);
var global = __webpack_require__(31);
var speciesConstructor = __webpack_require__(603);
var promiseResolve = __webpack_require__(606);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),

/***/ 633:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(96);
var newPromiseCapability = __webpack_require__(591);
var perform = __webpack_require__(605);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),

/***/ 634:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "admiracion.png?82d7beec2048090b980dc450afc6b635";

/***/ }),

/***/ 635:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dni-02-01.png?bda472fa019c09f137e1a66a59bd5570";

/***/ }),

/***/ 636:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dni-02-02.png?c49941b5a2620e453d36c157a1449b21";

/***/ }),

/***/ 637:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "loader.png?906bd902525a623d3491350af83d1e48";

/***/ }),

/***/ 638:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo-miraflores.png?cff0a8c460e3722444026239b9e6687d";

/***/ }),

/***/ 639:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ayuda.png?51f6c57ce3e8003900dde966283b625c";

/***/ }),

/***/ 640:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "file.png?d4b2242988738bfaccc36e19cda85bc4";

/***/ }),

/***/ 641:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "institucion.png?26c69573eb226fe3f67b8206890113ef";

/***/ }),

/***/ 642:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "arrow-left.png?2257d208e2577c8dd47570d6f2f19333";

/***/ }),

/***/ 643:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icono_save.png?1a8dd966401f7785138dcced880dde48";

/***/ }),

/***/ 644:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "calendar.png?fcf86537375baede7eb07c2ca0db8cd7";

/***/ }),

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "consulta_azul.png?b2ea00be4c036d8c2fd547860b079ccd";

/***/ }),

/***/ 649:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "login.png?579fc5ee9d4d0b517c6e715b16c7910c";

/***/ }),

/***/ 650:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mesadepartes.png?a6ed8e9844f9d976be5f7a84ab414ce8";

/***/ }),

/***/ 651:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "menu-circle-blue.png?3a4ddbf68b581068742f24b2bca9ee62";

/***/ }),

/***/ 652:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "left-arrow-blue.png?4ed9a44d2068bde2bba00ac40f2156f7";

/***/ }),

/***/ 653:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "user.png?e97a19018afa3007312be416b9376a4c";

/***/ }),

/***/ 654:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "download.png?2fdcfaab54fa40cd87768405a00fb3ae";

/***/ }),

/***/ 655:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "question.png?247431e9c7cda0d6e5c517bc7d1d8507";

/***/ }),

/***/ 656:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "carta.png?ace1507d002d9b4b805a9ff4520af857";

/***/ }),

/***/ 657:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "delete.png?bf9794eeca3acca9ceb7351914fefbb5";

/***/ }),

/***/ 658:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "personajuridica.png?a5216f227934ef2b0473f725dc5287ee";

/***/ }),

/***/ 659:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "personanatural.png?b7916691d075a41f7ca22061acd89835";

/***/ }),

/***/ 660:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "print_white_bold.png?9e6ef701834eba8ac59002328ee766b0";

/***/ }),

/***/ 661:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "tengaEnCuenta.png?728f78c184dd0682eb1ab42cd95f9524";

/***/ }),

/***/ 663:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./ICONO-HR-PU-2.png": 667,
	"./PopUp Web Muni.png": 668,
	"./adjuntar.png": 617,
	"./admiracion.png": 634,
	"./anexar.png": 669,
	"./arrow-left.png": 642,
	"./ask.png": 613,
	"./ayuda.png": 639,
	"./carta.png": 656,
	"./cartilla.png": 670,
	"./cartilla2.png": 671,
	"./cloud.png": 672,
	"./consulta_azul.png": 648,
	"./consultatutramite.png": 673,
	"./delete.png": 657,
	"./dni-02-01.png": 635,
	"./dni-02-02.png": 636,
	"./download.png": 654,
	"./estadodecuenta.png": 674,
	"./file.png": 640,
	"./flecha_derecha.png": 611,
	"./icono-consultas-linea.png": 675,
	"./icono_save.png": 643,
	"./imagen_mantenimiento.png": 676,
	"./images/calendar.png": 644,
	"./images/logo-muni-azul.png": 677,
	"./institucion.png": 641,
	"./left-arrow-black.png": 678,
	"./left-arrow-blue.png": 652,
	"./like.png": 679,
	"./loader.png": 637,
	"./login.png": 649,
	"./logo-miraflores.png": 638,
	"./logo-miraflores_old.png": 680,
	"./logo.png": 681,
	"./logo_miraflores_fblanco.png": 682,
	"./menu-blue.png": 683,
	"./menu-circle-blue.png": 651,
	"./menu.png": 684,
	"./mesadepartes.png": 650,
	"./nuevotramite.png": 685,
	"./pagoenlinea.png": 686,
	"./pdf.png": 609,
	"./personajuridica.png": 658,
	"./personanatural.png": 659,
	"./print_white_bold.png": 660,
	"./question.png": 655,
	"./requisito.png": 687,
	"./right-arrow-black.png": 688,
	"./right-arrow-blue.png": 689,
	"./solicitud.png": 690,
	"./success.png": 607,
	"./tengaEnCuenta.png": 661,
	"./tenis.png": 691,
	"./upload-cloud.png": 692,
	"./user.png": 653,
	"./userRegistro.png": 693
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 663;

/***/ }),

/***/ 666:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_EventBus_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_constantes_js__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tools_util__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_rentasService__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(358);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Login",
  data: function data() {
    return {
      pagina: __WEBPACK_IMPORTED_MODULE_3__store_constantes_js__["a" /* default */].mantenimiento,
      version: __WEBPACK_IMPORTED_MODULE_3__store_constantes_js__["a" /* default */].version,
      correo: "",
      contrasena: "",
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    };
  },

  props: {
    showModal: false
  },
  created: function created() {
    window.rutaReturn = window.rutaReturn ? window.rutaReturn : "/";
  },
  mounted: function mounted() {
    localStorage.setItem("logueadoTramite", false);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "pagina_vista",
      "page-url": "/login/",
      "page-title": "login"
    });
  },

  methods: {
    ValidaCorreoFormato: function ValidaCorreoFormato(correo) {
      return correo === "" ? false : this.reg.test(correo);
    },
    ValidarFormulario: function ValidarFormulario() {
      if (this.correo === "") {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Ingrese cuenta de usuario"
        });
        return false;
      }
      if (this.contrasena === "") {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Ingrese su contraseña"
        });
        return false;
      }
      return true;
    },
    IniciarSesion: function IniciarSesion() {
      var _this = this;

      if (this.ValidarFormulario()) {
        /*let PtdGenUsuarioLogin = { 'email': this.correo, 'clave': this.contrasena }
        const urlValidacion =Constantes.rutaAccesos +"acceso/obtener/";
        axios.post(urlValidacion,PtdGenUsuarioLogin)*/

        var bodyFormData = new FormData();
        bodyFormData.append('username', this.correo);
        bodyFormData.append('password', this.contrasena);
        bodyFormData.append('grant_type', 'password');
        var urlValidacion = __WEBPACK_IMPORTED_MODULE_3__store_constantes_js__["a" /* default */].rutaOauth;
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(urlValidacion, bodyFormData, {
          headers: {
            Authorization: 'Basic ' + btoa(__WEBPACK_IMPORTED_MODULE_3__store_constantes_js__["a" /* default */].Authorization)
          }
        }).catch(function (error) {
          return console.log(error);
        }).then(function (response) {
          if (response.toString().toUpperCase() === "Error: Request failed with status code 400".toUpperCase() || response.toString().toUpperCase() === "Error: Request failed with status code 401".toUpperCase()) {
            _this.controlErrorSesion(404);
          } else {
            if (response.data.success) {
              var data = response.data.data;
              localStorage.setItem('idVerificador', 1);
              localStorage.setItem("logueadoTramite", true);
              localStorage.setItem("nombreUsuarioLogueadoTramite", data.nombre);
              localStorage.setItem("fagCancha", data.flagAlquilerCancha);
              localStorage.setItem("paternoUsuarioLogueadoTramite", data.apePaterno);
              localStorage.setItem("maternoUsuarioLogueadoTramite", data.apeMaterno);
              localStorage.setItem("idUsuarioLogueadoTramite", data.idUsuario);
              localStorage.setItem("cuentaTrmaite", _this.correo);
              localStorage.setItem("idPersonaLogueadoTramite", data.idPersona);
              localStorage.setItem("nombreCompletoLogueadoTramite", data.apePaterno + " " + data.apeMaterno + " " + data.nombre);
              localStorage.setItem("numeroDocumentoLogueadoTramite", data.numeroDocumento);
              localStorage.setItem("correoNotificacionTramite", data.emailNotificacion);
              localStorage.setItem("restricciones", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.restricciones));
              __WEBPACK_IMPORTED_MODULE_4__tools_util__["a" /* default */].storage.set("usuarioMigrado", true);
              localStorage.setItem("token", response.data.token);
              localStorage.setItem("jwt", response.data.access_token);
              localStorage.setItem("expires_in", response.data.expires_in);

              var appRentas = {};
              appRentas.contribuyente = {};
              appRentas.contribuyente.numDoc = data.numeroDocumento;
              appRentas.contribuyente.nombres = data.apePaterno + " " + data.apeMaterno + ", " + data.nombre;
              appRentas.contribuyente.email = _this.correo;
              __WEBPACK_IMPORTED_MODULE_4__tools_util__["a" /* default */].storage.set("appRentas", appRentas);
              __WEBPACK_IMPORTED_MODULE_1__helpers_EventBus_js__["a" /* default */].$emit("login", data.nombre);
              //this.obtenerListadoDeshabilitado();              
              _this.$router.push(window.rutaReturn);
            } else if (response.data.existeUsuario) {
              if (response.data.activado) {
                _this.controlErrorSesion(404);
              } else {
                _this.controlErrorSesion(405);
              }
            } else {
              var dataLogin = {};
              dataLogin.email = _this.correo;
              dataLogin.pass = _this.contrasena;
              var mensajeLogin = response.data.message;
              localStorage.setItem("logueadoTramite", false);
              _this.$swal({
                icon: "error",
                title: "Error",
                text: mensajeLogin === "" || mensajeLogin == null ? "Verifique datos" : mensajeLogin
              });
            }
          }
        });
      }
    },
    obtenerListadoDeshabilitado: function obtenerListadoDeshabilitado() {
      var url = __WEBPACK_IMPORTED_MODULE_3__store_constantes_js__["a" /* default */].rutacitas + "obtener-horarios-no-disponibles";
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url).then(function (response) {
        var respuesta = response.data.lista;
        if (respuesta.length > 0) {
          // localStorage.setItem("listaNoDisponible", respuesta);
        }
      }).catch(function (e) {
        return console.log(e);
      });
    },
    validaUsuarioRentas: function validaUsuarioRentas(data) {
      var respuesta = true;
      if (data.tipDoc !== 32 && data.nombre.trim() + data.apePat.trim() + data.apeMat.trim() === '') {
        respuesta = false;
      }
      if (data.tipDoc === 32 && data.nombre.trim() + data.apePat.trim() + data.apeMat.trim() === '') {
        respuesta = false;
      }
      return respuesta;
    },
    lanzaServicio: function lanzaServicio(requestParams, nombreLogin) {
      if (requestParams.opcion === 0) {
        this.$router.push("/");
      } else if (requestParams.opcion === 1) {
        this.$router.push("/tramiteVirtual");
      } else if (requestParams.opcion === 2) {
        this.$router.push("/consultaTramite");
      } else if (requestParams.opcion === 5) {
        this.$router.push("/tramite/ce/" + localStorage.getItem("areaTramite") + "&" + localStorage.getItem("tipoTramite") + "&" + localStorage.getItem("idTramite") + "&0&0");
      } else if (requestParams.opcion === "pago-tributo") {
        this.$router.push("/pago-tributo");
      } else if (requestParams.opcion === "estado-cuenta") {
        this.$router.push("/estado-cuenta");
      }

      __WEBPACK_IMPORTED_MODULE_1__helpers_EventBus_js__["a" /* default */].$emit("login", nombreLogin);
    },
    controlErrorSesion: function controlErrorSesion(codigoError) {
      if (codigoError === 404) {
        this.$swal({
          icon: 'error',
          title: 'Error de inicio de sesión',
          html: "El usuario y/o la contraseña ingresados son incorrectos"
        });
      } else if (codigoError === 40401) {
        var mensaje = "<div style='line-height:24px;'>Por las mejoras realizadas en nuestra plataforma on line, solo podrán ingresar ";
        mensaje += "los contribuyentes registrados, para mayor información comuníquese al teléfono ";
        mensaje += "<br/><b>(01) 617-7555</b></div>";

        this.$swal({
          icon: 'warning',
          title: 'Alerta',
          html: mensaje
        });
      } else if (codigoError === 405) {
        this.$swal({
          icon: 'error',
          title: 'Error de inicio de sesión',
          html: "Debe activar su cuenta. Favor revise su correo electrónico."
        });
      } else if (codigoError === 500) {
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: 'Ocurrio un error inesperado'
        });
      }
    }
  }
});

/***/ }),

/***/ 667:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ICONO-HR-PU-2.png?2da089ca9055bbdf8aab1987c3d59e5c";

/***/ }),

/***/ 668:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "PopUp Web Muni.png?fc72fa9baa97cfc9433ecfd320148ae5";

/***/ }),

/***/ 669:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "anexar.png?6970a37041b50bee2a48f7015860ad86";

/***/ }),

/***/ 670:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cartilla.png?3db8a8901ab51fb87e4232b48dd50f2d";

/***/ }),

/***/ 671:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cartilla2.png?d863b087a1a61bef2d17c3ab9422254a";

/***/ }),

/***/ 672:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cloud.png?ce73578a5166a8f218fd1eaaa5f2e1ea";

/***/ }),

/***/ 673:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "consultatutramite.png?10fc0a013388afe78e7e77776f42bc13";

/***/ }),

/***/ 674:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "estadodecuenta.png?b859e8edb0f27c046bdd5899a8cac092";

/***/ }),

/***/ 675:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icono-consultas-linea.png?b6a65182ab5f6d298562e6da60332af6";

/***/ }),

/***/ 676:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "imagen_mantenimiento.png?99a763bd17e06ebe79d60c0df25b4813";

/***/ }),

/***/ 677:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo-muni-azul.png?c376f73e106e0a94ccb09c2488ca36c6";

/***/ }),

/***/ 678:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "left-arrow-black.png?3d136b26bbb01a99c6f9bdfca806fdfb";

/***/ }),

/***/ 679:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "like.png?236b8480e81a0a414cf0efe4e567055f";

/***/ }),

/***/ 680:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo-miraflores_old.png?c376f73e106e0a94ccb09c2488ca36c6";

/***/ }),

/***/ 681:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo.png?82b9c7a5a3f405032b1db71a25f67021";

/***/ }),

/***/ 682:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo_miraflores_fblanco.png?88505e4aacc0b9c7cee65f0dedebea75";

/***/ }),

/***/ 683:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "menu-blue.png?9fc2d09680c565d77f2c34483ae3f759";

/***/ }),

/***/ 684:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "menu.png?bb83fd3470002305dda1a484c0b81e69";

/***/ }),

/***/ 685:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nuevotramite.png?ea89c9e46b0659f3f14089bfdd5ca484";

/***/ }),

/***/ 686:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "pagoenlinea.png?9a7b1c511ac521e0e0bdb30d4479e361";

/***/ }),

/***/ 687:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "requisito.png?9eb1b8c22630fc6b417b99d8d13b71d7";

/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "right-arrow-black.png?0381888533aec9865a697533145bb75b";

/***/ }),

/***/ 689:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "right-arrow-blue.png?f62e661032c97d787427977cdf636148";

/***/ }),

/***/ 690:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "solicitud.png?16f5327e66493f38cd3e4fe402bfc515";

/***/ }),

/***/ 691:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "tenis.png?6dcb98888ffc96b9ba83d49d0f0920cc";

/***/ }),

/***/ 692:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "upload-cloud.png?ce73578a5166a8f218fd1eaaa5f2e1ea";

/***/ }),

/***/ 693:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "userRegistro.png?23aebaf8def8f408b7e596cf0df4a6e0";

/***/ }),

/***/ 838:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(!_vm.pagina)?_c('div',[_c('div',{staticClass:"card card-muni card-muni-min"},[_c('h3',[_vm._v("Iniciar sesión")]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6 col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.correo),expression:"correo"}],staticClass:"form-control",attrs:{"name":"user","type":"text"},domProps:{"value":(_vm.correo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.correo=$event.target.value}}})])]),_vm._v(" "),_c('router-link',{staticClass:"enlace4",attrs:{"to":"/busca-correo"}},[_vm._v("¿Olvidaste tu correo electrónico?")]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center mt-2"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6 col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contrasena),expression:"contrasena"}],staticClass:"form-control",attrs:{"name":"pass","type":"password"},domProps:{"value":(_vm.contrasena)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.IniciarSesion($event)},"input":function($event){if($event.target.composing){ return; }_vm.contrasena=$event.target.value}}})])]),_vm._v(" "),_c('router-link',{staticClass:"enlace4",attrs:{"to":"/recupera"}},[_vm._v("¿Olvidaste tu contraseña?")]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-12 text-center mt-3"},[_c('button',{staticClass:"btn btn-block btn-lg btn-default",attrs:{"name":"ingresar"},on:{"click":_vm.IniciarSesion}},[_vm._v("Ingresar")])])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-12 text-center"},[_vm._v("\n          ¿ Aún no tienes cuenta ?\n          "),_c('router-link',{staticClass:"enlace4",attrs:{"to":"/registroUsuarioOption"}},[_vm._v("Regístrate")])],1)])],1),_vm._v(" "),_c('footer',{staticClass:"text-muted text-center mt-3"},[_vm._v(_vm._s(_vm.version))])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-sm-6 col-md-12"},[_c('div',{staticClass:"mt-1 line15"},[_c('label',[_vm._v("Correo electrónico")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-sm-6 col-md-12"},[_c('div',{staticClass:"mt-2"},[_c('label',[_vm._v("Contraseña")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-12"},[_c('hr')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 956:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Login_vue__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tools_util__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_regenerator_runtime_runtime__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_regenerator_runtime_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_regenerator_runtime_runtime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_constantes_js__ = __webpack_require__(345);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Login: __WEBPACK_IMPORTED_MODULE_2__Login_vue__["default"] },
  data: function data() {
    return {
      flagCasillaElectronica: true,
      rutaTerminosCasilla: __WEBPACK_IMPORTED_MODULE_6__store_constantes_js__["a" /* default */].filesRecupera + "/14/1/0",
      estiloMuestraLogin: "",
      estiloMuestraUsuario: "none",
      mostrarDivPreLogin: true,
      nombreUsuario: "",
      lisItemsPagoDirecto: [],
      lisItems: [{
        title: "Trámites Virtuales",
        description: "Registra tus trámites de manera virtual.",
        link: "/plataformatramiteVirtual",
        icon: "mesadepartes",
        conIconDes: 0,
        login: 1
      },
      /* {
                  title : 'Consulte su Trámite',
                  description: 'Consulta el estado de tus trámites ingresados.',
                  link: '/consultaTramite',
                  icon: 'consultatutramite',
                  login: 1
              }
              , */
      {
        title: "Pago en Línea",
        description: "Realiza el pago de tu estado de cuenta.",
        link: "/pago-tributo",
        icon: "pagoenlinea",
        conIconDes: 0,
        login: 1
      }, {
        title: "Estado de Cuenta",
        description: "Consulta tu estado de cuenta.",
        link: "/estado-cuenta",
        icon: "estadodecuenta",
        conIconDes: 0,
        login: 1
      }, {
        title: "Cartilla Tributaria por año",
        description: "ICONO-HR-PU-2",
        link: "/contribuyente-cuponera",
        icon: "cartilla2",
        conIconDes: 1,
        login: 1
      }, {
        title: "Alquiler de cancha de tenis y pickelball",
        description: "Consulta y reserva tu cancha.",
        link: "/AlquilerTenis",
        icon: "tenis",
        conIconDes: 0,
        login: 1
      }]
    };
  },
  created: function created() {
    if (localStorage.getItem("validarEntradaToken") == 1) {
      localStorage.removeItem("validarEntradaToken");
      window.location.reload();
    }
    window.rutaReturn = "/";
    this.obtenerPagoDirecto();
    this.validaCasillaElectronica();
  },
  mounted: function mounted() {
    var appRentas = __WEBPACK_IMPORTED_MODULE_3__tools_util__["a" /* default */].storage.get("appRentas");
    if (appRentas != null && appRentas.cuenta != null) {
      delete appRentas.cuenta;
      __WEBPACK_IMPORTED_MODULE_3__tools_util__["a" /* default */].storage.set("appRentas", appRentas);
    }

    this.ValidaLogueo();
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "pagina_vista",
      "page-url": "/plataforma",
      "page-title": "plataforma"
    });
  },

  methods: {
    ValidaLogueo: function ValidaLogueo() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var flagLogueado;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return localStorage.getItem("logueadoTramite");

              case 2:
                flagLogueado = _context.sent;

                if (flagLogueado === "true") {
                  _this.mostrarDivPreLogin = false;
                  _this.estiloMuestraLogin = "none";
                  _this.estiloMuestraUsuario = "";
                  _this.nombreUsuario = localStorage.getItem("nombreCompletoLogueadoTramite");
                } else {
                  _this.mostrarDivPreLogin = true;
                  _this.estiloMuestraLogin = "";
                  _this.estiloMuestraUsuario = "none";
                  _this.nombreUsuario = localStorage.getItem("nombreCompletoLogueadoTramite");
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    validaOpc: function validaOpc(opc, link) {
      if (opc == 2 && this.$root.$userLogged == false) {
        this.$root.$userCuponera = false;
        this.$router.push(link);
      } else {
        this.$root.$userCuponera = true;
        this.$router.push(link);
      }
    },
    validaCasillaElectronica: function validaCasillaElectronica() {
      var valid = localStorage.getItem("idVerificador");
      if (valid == 1 && (__WEBPACK_IMPORTED_MODULE_3__tools_util__["a" /* default */].storage.get("persona") === undefined || __WEBPACK_IMPORTED_MODULE_3__tools_util__["a" /* default */].storage.get("persona") === null)) {
        __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_6__store_constantes_js__["a" /* default */].rutaTramite +
        //"detalleUsuarioPlataforma/", {headers: {"validaCasilla":true}
        "detalleUsuarioPlataforma/", { headers: { 'idUsr': localStorage.getItem('idUsuarioLogueadoTramite').toString(), 'validaCasilla': true }
        }).then(function (response) {
          var data = response.data.data;
          __WEBPACK_IMPORTED_MODULE_3__tools_util__["a" /* default */].storage.set("tipoDocumentoLogueado", data[0].persona.tipoDocumento);
          var casillaEletronica = data[0].flagCasillaElectronica;
          if (casillaEletronica != 1) {
            //this.$bvModal.show("modalCasillaElectronica");
          }
        }).catch(function (e) {
          return console.log(e);
        });
      }
    },
    openModalCasillaElectronica: function openModalCasillaElectronica() {
      this.$bvModal.show("visorModal");
    },
    ActualizaFlagCasillaElectronica: function ActualizaFlagCasillaElectronica() {
      var _this2 = this;

      if (this.flagCasillaElectronica) {
        var usuario = {};
        usuario.idUsuarioPlataforma = localStorage.getItem("idUsuarioLogueadoTramite");
        __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_6__store_constantes_js__["a" /* default */].rutaTramite + "activaCasillaElectronica/", usuario).then(function (response) {
          if (response.data.success) {
            //this.$bvModal.hide("modalCasillaElectronica");
            _this2.$swal.fire({
              icon: "success",
              title: "Se acepto terminos y condiciones",
              showConfirmButton: false,
              timer: 1900
            });
          } else {
            _this2.$swal({
              icon: "info",
              title: "Aviso",
              text: "Sucedió un error al actualizar"
            });
          }
        }).catch(function (e) {
          return console.log(e);
        });
      } else {
        this.omitir();
      }
    },
    omitir: function omitir() {
      localStorage.setItem("idVerificador", 0);
      this.$bvModal.hide("modalCasillaElectronica");
    },
    clearData: function clearData() {
      localStorage.setItem("idVerificador", 0);
    },
    obtenerPagoDirecto: function obtenerPagoDirecto() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_6__store_constantes_js__["a" /* default */].rutaTramite + "obtenerPagoDirecto/", []).then(function (response) {
        if (response.data.data) {
          _this3.lisItemsPagoDirecto = response.data.data;
        }
      }).catch(function (e) {
        return console.log(e);
      });
    },
    verTramitePagoDirecto: function verTramitePagoDirecto(row) {
      //let endpoint = "/descripcion/" + +row.id_area+"&"+row.idRequisitoTramite+"&0&2&1";
      var endpoint = "/pagodirecto/ce/" + row.id_area + "&" + row.idRequisitoTramite + "&0&2&1";
      this.$router.push(endpoint);
    }
  }
});

/***/ })

});


// WEBPACK FOOTER //
// 0.af1a5ef800fe46f72e30.bundle.js?v0.8910010824215415